import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { useFormContext } from 'react-hook-form';
import Button from 'jbc-front/components/Button';
import { ScrollSpy } from 'jbc-front/components/ScrollSpy/v2';
import { AnchorTarget } from '@/components/AnchorTarget';
import { Navi } from '../Navi';
import { DateOn } from './DateOn';
import { Office } from './Office';
import { HealthCheckupInstitution } from './HeahthCheckupInstitution';
import { MedicalHistory } from './MedicalHistory';
import { Symptoms } from './Symptoms';
import { Height } from './Height';
import { Weight } from './Weight';
import { AbdominalCircumference } from './AbdominalCircumference';
import { Vision } from './Vision';
import { Hearing } from './Hearing';
import { ChestXRay } from './ChestXRay';
import { SputumTest } from './SputumTest';
import { BloodPressure } from './BloodPressure';
import { AnemiaTest } from './AnemiaTest';
import { LiverFunctionTest } from './LiverFunctionTest';
import { BloodLipidTest } from './BloodLipidTest';
import { BloodSugarTest } from './BloodSugarTest';
import { Urine } from './Urine';
import { Electrocardiogram } from './Electrocardiogram';
import { OrderByDoctor } from './OrderByDoctor';
import { SpecifiedWorks } from './SpecifiedWorks';
import { Report } from './Report';
import styles from './Form.scss';

interface FormProps {
  personalId: string;
  onSubmit: () => void;
  onCancel: () => void;
}

export const Form: FC<FormProps> = ({ personalId, onSubmit, onCancel }) => {
  const location = useLocation();
  const {
    formState: { isSubmitting }
  } = useFormContext();

  return (
    <ScrollSpy location={location}>
      <div className={styles.row}>
        <div>
          <Navi>
            <Button primary widthWide onClick={onSubmit} disabled={isSubmitting}>
              保存
            </Button>
          </Navi>
        </div>

        <div>
          <AnchorTarget name="date_on" />
          <DateOn personalId={personalId} />

          <AnchorTarget name="office" />
          <Office />

          <AnchorTarget name="health_checkup_institution" />
          <HealthCheckupInstitution />

          <AnchorTarget name="medical_history" />
          <MedicalHistory />

          <AnchorTarget name="symptoms" />
          <Symptoms />

          <AnchorTarget name="height" />
          <Height />

          <AnchorTarget name="weight" />
          <Weight />

          <AnchorTarget name="abdominal_circumference" />
          <AbdominalCircumference />

          <AnchorTarget name="vision" />
          <Vision />

          <AnchorTarget name="hearing" />
          <Hearing />

          <AnchorTarget name="chest_x_ray" />
          <ChestXRay />

          <AnchorTarget name="sputum_test" />
          <SputumTest />

          <AnchorTarget name="blood_pressure" />
          <BloodPressure />

          <AnchorTarget name="anemia_test" />
          <AnemiaTest />

          <AnchorTarget name="liver_function_test" />
          <LiverFunctionTest />

          <AnchorTarget name="blood_lipid_test" />
          <BloodLipidTest />

          <AnchorTarget name="blood_sugar_test" />
          <BloodSugarTest />

          <AnchorTarget name="urine" />
          <Urine />

          <AnchorTarget name="electrocardiogram" />
          <Electrocardiogram />

          <AnchorTarget name="order_by_doctor" />
          <OrderByDoctor />

          <AnchorTarget name="specified_works" />
          <SpecifiedWorks />

          <AnchorTarget name="report" />
          <Report />

          <div className="u-ta-c u-mt30">
            <Button className="u-mr20" onClick={onCancel} disabled={isSubmitting}>
              キャンセル
            </Button>
            <Button primary onClick={onSubmit} disabled={isSubmitting}>
              保存
            </Button>
          </div>
        </div>
      </div>
    </ScrollSpy>
  );
};
